import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import { all_routes } from "../../../feature-module/router/all_routes";
import { t } from "../../../lang/index";

const Footer = () => {
  const routes = all_routes;

  const footer = t("footer");

  return (
    <footer>
      <div className="container">
        <div className="footer-top">
          <div className="row justify-content-center row-cols-lg-5 row-cols-md-3 row-cols-sm-2 row-cols-1">
            {/* Pages */}
            <div className="col">
              <div className="footer-widget">
                <h5>{footer.pages.title}</h5>
                <ul className="footer-menu">
                  <li><Link to={routes.profileSettings}>{footer.pages.settings}</Link></li>
                  <li><Link to={routes.myProfile}>{footer.pages.profile}</Link></li>
                  <li><Link to={routes.feed}>{footer.pages.social}</Link></li>
                </ul>
              </div>
            </div>

            {/* Company */}
            <div className="col">
              <div className="footer-widget">
                <h5>{footer.company.title}</h5>
                <ul className="footer-menu">
                  <li><Link to={routes.about_us}>{footer.company.about}</Link></li>
                  <li><Link to={routes.Testimonials}>{footer.company.testimonials}</Link></li>
                  <li><Link to={routes.FAQ}>{footer.company.faq}</Link></li>
                </ul>
              </div>
            </div>

            {/* Support */}
            <div className="col">
              <div className="footer-widget">
                <h5>{footer.support.title}</h5>
                <ul className="footer-menu">
                  <li><Link to={routes.contactUs}>{footer.support.contact}</Link></li>
                  <li><Link to={routes.privacyPolicy}>{footer.support.privacy}</Link></li>
                  <li><Link to={routes.termsConditions}>{footer.support.terms}</Link></li>
                  <li><Link to={routes.userSupport}>{footer.support.chat}</Link></li>
                </ul>
              </div>
            </div>

            {/* Services */}
            <div className="col">
              <div className="footer-widget">
                <h5>{footer.services.title}</h5>
                <ul className="footer-menu">
                  <li><Link to={routes.flightGrid}>{footer.services.tuktuk}</Link></li>
                  <li><Link to="#">{footer.services.winery}</Link></li>
                  <li><Link to="#">{footer.services.restaurant}</Link></li>
                  <li><Link to="#">{footer.services.car}</Link></li>
                  <li><Link to="#">{footer.services.hippotrip}</Link></li>
                  <li><Link to="#">{footer.services.bike}</Link></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="footer-img">
            <ImageWithBasePath src="assets/img/bg/footer.svg" className="img-fluid" alt="footer" />
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <p className="fs-14">
                  {footer.bottom.copyright}{" "}
                  <Link to="#" className="text-primary fw-medium">
                    {footer.bottom.brand}
                  </Link>
                </p>

                <ul className="social-icon">
                  {footer.bottom.social.map((icon: any, idx: number) => (
                    <li key={idx}>
                      <Link to={icon.link}>
                        <i className={icon.icon} />
                      </Link>
                    </li>
                  ))}
                </ul>

                <ul className="card-links">
                  {footer.bottom.cards.map((img: string, idx: number) => (
                    <li key={idx}>
                      <Link to="#">
                        <ImageWithBasePath src={img} alt="card" />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
